<template>
    <section id="download">
        <div class="main">
            <button @click="downloadClick()"></button>
        </div>
        <div class="is_weixin" v-if="isWeixin"></div>
    </section>
</template>

<script>
    import { is_weixin, downLoadApp } from '../../assets/js/download';
    export default {
        name: "download",
        created () {
            document.title = '下载优托邦APP';
            setTimeout(function () {
                if (!is_weixin()) {
                    downLoadApp();
                }
            }, 1000);
        },
        data () {
            return {
                // 是否在微信浏览器中
                isWeixin: false,
            }
        },
        methods: {
            downloadClick () {
                if (is_weixin()) {
                    this.isWeixin = true
                } else {
                    downLoadApp();
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/css/px2rem.scss';
    #download{
        height: px2rem(582);
        .main{
            height: 100%;
            background: url('../../assets/img/download/download.png') no-repeat center;
            background-size: 100% 100%;
            position: relative;
            button{
                width: px2rem(185);
                height: px2rem(44);
                position: absolute;
                left: 50%;
                bottom: px2rem(50);
                transform: translateX(-50%);
                background: url('../../assets/img/download/download_button_nor@2x.png') no-repeat center;
                background-size: 100% 100%;
                border:none;
                border-radius: px2rem(22);
            }
        }
        .is_weixin{
            position: fixed;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: rgba(0,0,0,0.3);
        }
    }
</style>
